export default {
  setSetup(state, setup) {
    state.setup = setup;
  },
  setLoading(state, loading) {
    state.loading = loading;
  }
};
